import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { logoService } from "@/services/api/cresivoxServer";

import { REDUCER_NAME, iLogoDTO,UpdateThemePayload } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const createLogo = createAsyncThunk<
  iGenericResponse<any | null> | null,
  iLogoDTO,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("createLogo"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async (payload, {rejectWithValue}) => {
    try {
      const response = await logoService.createLogo(payload);
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_CREATED: {
            if (data && data.data) {
              return {
                data: {
                  orders: data.data?.order,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

export const updateLogo = createAsyncThunk<
  iGenericResponse<any | null> | null,
  {LogoId: string, data: iLogoDTO},
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("updateLogo"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async ({LogoId, data}, {rejectWithValue}) => {
    try {
      const response = await logoService.updateLogo(LogoId, data);
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

// export const updateTheme = createAsyncThunk<
//   iGenericResponse<any | null>,
//   {
//     LogoId: string;
//     body: { currentTheme: string };
//   },
//   {
//     rejectValue: iStateMessage;
//   }
// >(
//   curriedGetThunkName("updateTheme"),
//   // @ts-expect-error
//   async ({ LogoId, body }, { rejectWithValue }) => {
//     try {
      
//       const response = await logoService.updateTheme(LogoId, body);

//       if (response) {
//         const { httpStatusCode, data, message } = response;

//         if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
//           return {
//             data: data.data,
//             message,
//           };
//         }

//         return rejectWithValue({
//           httpStatusCode,
//           message,
//         });
//       }

//       return rejectWithValue({
//         message: "No response received",
//       });
//     } catch (error) {
//       console.error("🚀 ~ error:", error);
//       return rejectWithValue({
//         message: "Something went wrong",
//       });
//     }
//   }
// );

export const updateTheme = createAsyncThunk<
  iGenericResponse<any | null>,
  {
    LogoId: string;
    body: UpdateThemePayload;
  },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("updateTheme"),
  // @ts-expect-error
  async ({ LogoId, body }, { rejectWithValue }) => {
    try {
      const response = await logoService.updateTheme(LogoId, body);

      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
          return {
            data: data.data,
            message,
          };
        }

        return rejectWithValue({
          httpStatusCode,
          message,
        });
      }

      return rejectWithValue({
        message: "No response received",
      });
    } catch (error) {
      console.error("🚀 ~ error:", error);
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);


export const getLogoList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("LogoList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
    try {
      const response = await logoService.getAllLogo();
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  httpStatusCode,
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

export const deleteLogo = createAsyncThunk<
  iGenericResponse<any | null> | null,
  {LogoId: string},
  {
    rejectValue: iStateMessage;
  }
>(
    
  curriedGetThunkName("deleteLogo"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({LogoId}, {rejectWithValue}) => {
    try {
      const response = await logoService.deleteLogo(LogoId);
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);

